<template>
  <div>
    <div class="df aic mt10 mr10">
      <!--      <div class="label">搜索地点</div>-->
      <!--      <el-autocomplete-->
      <!--        :fetch-suggestions="querySearch"-->
      <!--        :placeholder="placeholder"-->
      <!--        @select="handleChange"-->
      <!--        style="width:100%"-->
      <!--        v-model="searchValue"-->
      <!--      >-->
      <!--        <template slot-scope="{ item }">-->
      <!--          <div style="line-height: 20px;display:flex;align-items:center;">-->
      <!--            <i-->
      <!--              class="el-icon-search el-input__icon"-->
      <!--              slot="suffix"-->
      <!--              style="font-size:20px;margin-right:10px;"-->
      <!--            ></i>-->
      <!--            <span class="ele-form-search-keywords">{{item.value}}&nbsp;&nbsp;</span>-->
      <!--            <span class="ele-form-search-location">{{item.address}}</span>-->
      <!--          </div>-->
      <!--        </template>-->
      <!--      </el-autocomplete>-->
    </div>
    <div class="df aic mr10">
      <div class="label">经纬坐标</div>
      <el-input class="mt10" disabled v-model="pointString"></el-input>
    </div>
    <baidu-map
      :ak="ak"
      :center="center"
      :scroll-wheel-zoom="isScrollWheelZoom"
      :style="{ height: mapHeight + 'px' }"
      :zoom="zoom"
      @click="handleChange"
      @load="handleMapLoaded"
      class="ele-form-bmap"
      ref="bmap"
    >
      <bm-geolocation
        :autoLocation="true"
        :showAddressBar="false"
        @locationSuccess="handleChange"
        anchor="BMAP_ANCHOR_BOTTOM_RIGHT"
        v-if="isShowGeolocation"
      ></bm-geolocation>
      <!--      <bm-navigation-->
      <!--        anchor="BMAP_ANCHOR_TOP_LEFT"-->
      <!--        v-if="isShowNavigation"-->
      <!--      ></bm-navigation>-->
      <bm-control
        :offset="{ width: '10px', height: '10px' }"
        anchor="BMAP_ANCHOR_TOP_RIGHT"
      >
        <bm-auto-complete
          @comfirm="confirm"
          v-model="keyword"
          :sugStyle="{ zIndex: 1 }"
        >
          <el-input
            v-model="area"
            style="width:300px;border: 2px solid #0f2d2d;"
            placeholder="请输入地名关键字"
          ></el-input>
          <!-- 这里指代一个自定义搜索框组件 -->
        </bm-auto-complete>
      </bm-control>
      <bm-local-search
        :panel="false"
        :keyword="keyword"
        :auto-viewport="true"
      ></bm-local-search>
      <!--      <bm-local-search-->
      <!--        :auto-viewport="false"-->
      <!--        :keyword="searchValue"-->
      <!--        :pageCapacity="10"-->
      <!--        :panel="false"-->
      <!--        @searchcomplete="handleSearchEnd"-->
      <!--        v-if="isSearching"-->
      <!--      ></bm-local-search>-->
      <bm-marker :dragging="true" :position="center" @dragend="handleChange">
        <bm-info-window :show="true" :width="0" :height="0">
          <div v-html="value.name"></div>
        </bm-info-window>
      </bm-marker>
      <bm-view
        :style="{ height: mapHeight + 'px' }"
        style="width:100%"
      ></bm-view>
    </baidu-map>
  </div>
</template>

<script>
import BaiduMap from "vue-baidu-map/components/map/Map.vue";
import BmView from "vue-baidu-map/components/map/MapView";
import BmLocalSearch from "vue-baidu-map/components/search/LocalSearch";
import BmNavigation from "vue-baidu-map/components/controls/Navigation";
import BmControl from "vue-baidu-map/components/controls/Control";
import BmGeolocation from "vue-baidu-map/components/controls/Geolocation";
import BmMarker from "vue-baidu-map/components/overlays/Marker";
import BmInfoWindow from "vue-baidu-map/components/overlays/InfoWindow";
import BmAutoComplete from "vue-baidu-map/components/others/AutoComplete";
import { ak } from "@/config.js";
export default {
  name: "ele-form-bmap",
  props: {
    // 值
    value: {
      type: [String, Object]
    },
    // 缩放比
    zoom: {
      type: Number,
      default: 14
    },
    // 滚轮缩放大小
    isScrollWheelZoom: {
      type: Boolean,
      default: true
    },
    // 地图高度
    mapHeight: {
      type: Number,
      default: 400
    },
    // 是否显示缩略控件
    isShowNavigation: {
      type: Boolean,
      default: true
    },
    // 是否显示自动定位控件
    isShowGeolocation: {
      type: Boolean,
      default: true
    },
    // 搜索占位
    placeholder: {
      type: String,
      default: "请搜索位置"
    }
  },
  components: {
    BaiduMap,
    BmView,
    BmNavigation,
    BmLocalSearch,
    BmGeolocation,
    BmMarker,
    BmInfoWindow,
    BmAutoComplete,
    BmControl
  },
  data() {
    return {
      area: "",
      center: "杭州",
      isSearching: false,
      searchList: [],
      searchValue: "",
      pointString: "",
      keyword: "",
      ak: ak
    };
  },
  watch: {
    value: {
      handler: function(val) {
        if (val && val.lat && val.lng) {
          this.pointString = val.lat + "," + val.lng;
        }
      },
      immediate: true
    }
  },
  methods: {
    confirm(type, target, item) {
      console.log(type);
      console.log(target);
      console.log(item);
    },
    // 地图加载成功
    handleMapLoaded() {
      if (this.value) {
        this.center = this.value;
        if (typeof this.value === "string") {
          this.searchValue = this.value;
        } else if (typeof this.value === "object" && this.value.address) {
          this.searchValue = this.value.address;
        }
      }
    },
    // 发起请求
    querySearch(queryString, cb) {
      if (queryString) {
        // this.$refs.bmap.map.clearOverlays();
        setTimeout(() => {
          this.isSearching = true;
          this.cb = cb;
        }, 0);
      }
    },
    // 搜索结束
    handleSearchEnd(res) {
      console.log(res);
      if (res && res.Xr && this.cb) {
        const list = res.Xr.map(pos => {
          return {
            address: pos.address,
            point: pos.point,
            value: pos.title
          };
        });
        this.cb(list);
        this.cb = null;
        this.isSearching = false;
      } else if (res && res.LR && this.cb) {
        const list = res.Xr.map(pos => {
          return {
            address: pos.address,
            point: pos.point,
            value: pos.title
          };
        });
        this.cb(list);
        this.cb = null;
        this.isSearching = false;
      }
    },
    // 位置改变
    handleChange(res) {
      if (res && res.point) {
        this.center = res.point;
        this.$emit("input", {
          name: this.searchValue,
          lat: res.point.lat,
          lng: res.point.lng
        });
        this.pointString = res.point.lat + "," + res.point.lng;
      }
    }
  }
};
</script>

<style scoped>
.ele-form-bmap {
  width: 100%;
  margin-top: 20px;
  border-radius: 5px;
  overflow: hidden;
}
.label {
  width: 90px;
  flex-grow: 0;
  flex-shrink: 0;
  margin-left: 10px;
}
.ele-form-search-keywords {
  max-width: 80%;
  text-overflow: ellipsis;
  overflow: hidden;
}

.ele-form-search-location {
  font-size: 12px;
  color: #b4b4b4;
}
.highlighted .ele-form-search-location {
  color: #ddd;
}
</style>



// WEBPACK FOOTER //
// src/components/baiduMap/index.vue